// The Loft: command pattern — `Loft: <verb> "<name>" ...`. Loft is read-only;
// buttons don't perform actions, they copy one of these commands to the
// clipboard for the user to paste to Claude, which does the real work.

// Clipboard write with a legacy fallback — copying a command is the whole point.
export const writeClipboard = (text: string) => {
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(text).catch(() => {});
    return;
  }
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.style.position = 'fixed';
  ta.style.opacity = '0';
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand('copy');
  } finally {
    document.body.removeChild(ta);
  }
};

export const loftShareCommand = (name: string): string =>
  `Loft: share "${name}" for feedback`;

// Create is deliberately ticket-less (Sandbox is pre-ticket). An optional Linear
// project URL links the prototype to its project from the start — an initiative
// association, not a ticket — so the eventual ticket lands in the right place.
export const loftCreateCommand = (
  name: string,
  app?: string,
  linearProjectUrl?: string,
): string =>
  `Loft: create prototype "${name}" in Sandbox` +
  (app ? ` on ${app}` : '') +
  (linearProjectUrl ? ` - linked to ${linearProjectUrl}` : '');

// A pointer to one mini on a flows page. A flows page renders dozens of screens
// at once and not one of them is a route, so "the sixth one along" is the only
// way to say which you mean out loud. This is that, in a form Claude can grep:
// the page, the mini's own label, the flow or group it sits in, and the id the
// spec gives it — which is what the render is keyed by in the spec file.
export const handoverPointer = (p: {
  kind: 'Step' | 'State' | 'Pattern' | 'Interaction';
  label: string;
  id: string;
  group?: string;
}): string =>
  [
    window.location.pathname,
    `${p.kind}: ${p.label}`,
    p.group ? `In: ${p.group}` : null,
    `Id: ${p.id}`,
  ]
    .filter(Boolean)
    .join('\n');
